export default __webpack_public_path__ + "static/media/star-filled.daa9607d.svg";